import { useContext } from 'react';
import { ConfirmDialogContext } from 'shared/providers/confirm-dialog.provider';

const useConfirmDialog = () => useContext(ConfirmDialogContext);

export default useConfirmDialog;
